import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import noop from 'lodash/fp/noop';
import classNames from 'classnames';
import TreeSidebarCategories from './TreeSidebarCategories';
const TreeSidebar = React.memo((props) => {
    const { className, onClick = noop } = props, remainingProps = __rest(props, ["className", "onClick"]);
    const classes = classNames('TreeSidebar', className);
    return (_jsxs("div", Object.assign({ className: classes }, { children: [_jsx("ul", Object.assign({ className: 'TreeSidebarNavigation', onClick: onClick }, { children: _jsx(TreeSidebarCategories, Object.assign({}, remainingProps)) })), _jsx("div", Object.assign({ className: 'TreeSidebarToggle', onClick: onClick }, { children: _jsx("span", { className: 'rioglyph rioglyph-chevron-left' }) }))] })));
});
TreeSidebar.displayName = 'TreeSidebar';
export default TreeSidebar;
